import { z } from 'zod';

/**
 * Result of a successful `AdhocSubmission` run. Loose so fields autopilot adds later pass.
 * `quoteNumber` is the resolved quote; it differs from the input when a policy number was given.
 */
export const adhocSubmissionResultSchema = z.looseObject({
  quoteNumber: z.string(),
  policyNumber: z.string().nullable(),
});
export type AdhocSubmissionResult = z.infer<typeof adhocSubmissionResultSchema>;

/** `ApplicationError.type` values autopilot uses for failures before any side effect can occur. */
export const ADHOC_INVALID_INPUT_ERROR = 'AdhocInvalidInputError';
export const ADHOC_APPLICATION_UNAVAILABLE_ERROR = 'AdhocApplicationUnavailableError';
export const ADHOC_APPLICATION_EXCLUDED_ERROR = 'AdhocApplicationExcludedError';

/**
 * Failure types raised while resolving the application, before the processing pipeline starts.
 * A run that failed with one of these produced no side effects.
 */
export const ADHOC_RESOLVE_FAILURE_TYPES: readonly string[] = [
  ADHOC_INVALID_INPUT_ERROR,
  ADHOC_APPLICATION_UNAVAILABLE_ERROR,
  ADHOC_APPLICATION_EXCLUDED_ERROR,
];

/** Failure recorded for a run: autopilot's `ApplicationError.type` (when any) and its message. */
export const submissionFailureSchema = z.object({
  type: z.string().nullable(),
  message: z.string(),
});
export type SubmissionFailure = z.infer<typeof submissionFailureSchema>;
